import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { NgbModalConfig } from "@ng-bootstrap/ng-bootstrap";
import { AuthenticationService } from "src/app/services/authentication.service";
import { Globals } from "../shared/globals";
import { ILayer } from "../interface/layer";
import { IUser } from "src/app/interface/user";
import { environment } from "src/environments/environment";
import { EventEmittersService } from "../services/event-emitters.service";
import { GenericMapMethodsService } from "../services/generic-map-methods.service";
import { QueryLayersService } from "../services/query-layers.service";
import Swal from "sweetalert2";
import { TranslateService, TranslateModule } from "@ngx-translate/core";
import { QueryBuilderService } from "../services/query-builder.service";
import { CustomTranslatePipe } from "../shared/custom-translate.pipe";
import { MatIconModule } from "@angular/material/icon";
import { NgClass, NgIf } from "@angular/common";
import { ILayerSelections } from "../interface/selectedSet";
@Component({
    selector: "sms-select-tool",
    templateUrl: "./select-tool.component.html",
    styleUrls: ["./select-tool.component.scss"],
    standalone: true,
    imports: [NgClass, MatIconModule, NgIf, TranslateModule, CustomTranslatePipe]
})
export class SelectToolComponent implements OnInit {
  constructor(
    public objGlobals: Globals,
    private authenticationService: AuthenticationService,
    private queryLayersService : QueryLayersService,
    config: NgbModalConfig,
    public eeService: EventEmittersService,
    public genericMapMethodsService: GenericMapMethodsService,
    public translateService: TranslateService,
    public qbService: QueryBuilderService,
  ) {
    this.currentUser = this.authenticationService.currentUserValue;
  }

  @Output() data = new EventEmitter();
  @Output() assetTableVisibilityChanged = new EventEmitter<boolean>();
  @Output() assetViewerVisibilityChanged = new EventEmitter<boolean>();
  @Output() taskTableVisibilityChanged = new EventEmitter<boolean>();
  @Output() index = new EventEmitter();
  @Output() layerIndex = new EventEmitter();

  @Input() map: any;
  @Input() all: any;
  @Input() SimpleFillSymbol: any;
  @Input() SimpleLineSymbol: any;
  @Input() Query: any;
  @Input() QueryTask: any;
  @Input() drawTool: any;
  @Input() Color: any;
  @Input() Graphic: any;
  @Input() SimpleMarkerSymbol: any;
  @Input() FeatureLayer: any;
  @Input() GraphicsLayer: any;
  @Input() Point: any;
  @Input() webMercatorUtils: any;
  @Input() PictureMarkerSymbol: any;

  public isDrawExtentEnabled = true;
  public isDrawPolygonEnabled = false;
  public selectedSet: ILayerSelections[] = [];
  public gridView = false;
  public cardView = false;
  public maintenanceView = false;
  public queriedLayers = [];
  public currentUser: IUser;
  // public category:any;
  public inventoryLayersData: ILayer[] = [] as ILayer[];
  public selectGraphicslayer: any;

  public parenttasksCount;

  //Added for visulization layers
  visualizationLayersData: any[] = [];

  ngOnInit() {
    this.objGlobals.IsAssetViewerClosed = true;
    this.objGlobals.IsGridViewClosed = true;
    this.objGlobals.IsMntViewClosed = true;
    this.inventoryLayersData = this.eeService.userLayers.filter((lyr) => lyr.type === "inventory");
    this.selectGraphicslayer = this.map.smsLayerdata.graphicLayers[0]; // by default first layer
    this.visualizationLayersData = [];
    if (this.map.visualizationLayers != undefined) {
      this.visualizationLayersData = this.map.visualizationLayers; //Added for visulization layers
    }
    if (this.objGlobals.complaintID != null && this.objGlobals.complaintID !== "" && this.objGlobals.complaintID !== undefined) {
      this.objGlobals.closeCrowdSource = true;
    }

    if (
      this.objGlobals.latitude != null &&
      this.objGlobals.latitude !== undefined &&
      this.objGlobals.latitude !== "" &&
      this.objGlobals.longitude != null &&
      this.objGlobals.longitude !== undefined &&
      this.objGlobals.longitude !== ""
    ) {
      this.fnClearSelection();
      const geopint = new this.Point({
        x: this.objGlobals.longitude,
        y: this.objGlobals.latitude,
        spatialReference: { wkid: 4326 }
      });
      this.map.centerAndZoom(geopint, 15);
      const selectionPointSymbol = new this.SimpleMarkerSymbol(
        this.SimpleMarkerSymbol.STYLE_CIRCLE,
        12,
        new this.SimpleLineSymbol(this.SimpleLineSymbol.STYLE_NULL, new this.Color([247, 34, 101, 0.9]), 1),
        new this.Color([0, 255, 255, 9])
      );
      const pointingsymbol = new this.Graphic(geopint, selectionPointSymbol);
      this.map.graphics.add(pointingsymbol);
    }

    this.map.on("click", this.myClickHandler);
  }
  myClickHandler() {
    console.log("map clickedd");
  }
  ngAfterViewInit() {
    if (
      this.objGlobals.latitude != null &&
      this.objGlobals.latitude !== undefined &&
      this.objGlobals.latitude !== "" &&
      this.objGlobals.longitude != null &&
      this.objGlobals.longitude !== undefined &&
      this.objGlobals.longitude !== ""
    ) {
      this.map.enableMapNavigation();
      this.objGlobals.latitude = null;
      this.objGlobals.longitude = null;
    } else {
      this.fnDraw();
    }
  }

  optionClicked(event: any, type: string) {
    try {
      if (type === "Clear" || type === "Extent" || type === "Polygon") {
        this.fnClearSelection();
        this.isDrawExtentEnabled = type === "Extent" && !this.isDrawExtentEnabled ? true : false;
        this.isDrawPolygonEnabled = type === "Polygon" && !this.isDrawPolygonEnabled ? true : false;
        if (this.isDrawExtentEnabled || this.isDrawPolygonEnabled) {
          this.fnDraw();
        }
      } else if (this.selectedSet?.length > 0) {
        if (type === "AssetTable") {
          this.eeService.setAssetTable();
        } else if (type === "TaskTable") {
          this.eeService.setMaintenanceView();
        } else if (type === "AssetViewer") {
          this.eeService.setAssetViewer();
          this.eeService.addNewParent = false;
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  fnDraw() {   // select features by Extent(Rectangle) & Polygon
    try {
      this.eeService.setAssetViewer(false);
      this.eeService.setAssetTable(false);
      this.map.disableMapNavigation();
      this.eeService.setEnableSingleClick(false);
      this.genericMapMethodsService.queryBuilderZoomExtent = false; //TSDRSAM-1655
      this.drawTool.component = "select";

      // activate draw tool
      this.drawTool.activate( this.isDrawExtentEnabled ? "extent" : "polygon" );

      // on draw-end
      const handler = this.drawTool.on("draw-end", (evt) => {    
        handler.remove(); // remove draw-end handler to avoid multiple triggers
        this.deactivateDraw();
        this.map.enableMapNavigation();
        this.selectedSet = this.eeService.selectFeaturesByGeometry(evt.geometry);
      });
    } catch (error) {
      console.error(error);
    }
  }

  fnClearSelection() {
    try {
      this.map.graphicsLayerIds.forEach((id) => {
          this.map.getLayer(id).clear();
      });
      this.map.graphics.clear();  // red active asset pin
      this.assetTableVisibilityChanged.emit(false);
      this.assetViewerVisibilityChanged.emit(false);
      this.taskTableVisibilityChanged.emit(false);
      this.data.emit([]);
      this.deactivateDraw();
      this.map.enableMapNavigation();
      this.clearLayerSelection();
      this.selectedSet = [];
      this.eeService.setAssetViewer(false);
      this.eeService.setAssetTable(false);
      this.eeService.setSelectedFeaturesOnMap([]);
      this.eeService.setEnableSingleClick(true);
    } catch (error) {
      console.error(error);
    }
  }

  deactivateDraw() {
    try {
      this.drawTool.editingEnabled = false;
      this.drawTool.deactivate();
      this.isDrawExtentEnabled = false;
      this.isDrawPolygonEnabled = false;
    } catch (error) {
      console.error(error);
    }
  }
  
  clearLayerSelection() {
    try {
      const inventoryLayers = this.eeService.userLayers.filter((lyr) => lyr.type === "inventory");
      inventoryLayers.forEach( (lyr) => {
        lyr.lyrObj?.clearSelection();
      });
    } catch (error) {
      console.error(error);
    }
  }

}
